<template>
  <header id="main-header" class="c-header c-header--dark">
    <nav
      class="c-nav d-flex h-100 align-items-center justify-content-between"
      :class="`container${ type }`">
      <ul class="c-nav__left c-menu ul-reset h-100 d-flex align-items-center">
        <li class="me-4">
          <a href="/">
            <figure class="c-brand c-brand--normal d-flex align-items-center">
              <img
                class="of--contain w-100 h-100"
                src="../assets/images/arcux/arcux.svg"
                title="Arcux"
                alt="Arcux"
              >
            </figure>
          </a>
        </li>

        <template v-if="!single">
          <!-- MENU desktop   -->
            <b-skeleton-wrapper :loading="headerLoading">
              <template #loading>
                <div class="br--small overflow-hidden d-flex gap-3 flex-row me-3">
                <b-skeleton-img
                  no-aspect
                  animation="fade"
                  width="60px"
                  height="40px">
                </b-skeleton-img>
                <b-skeleton-img
                  no-aspect
                  animation="fade"
                  width="60px"
                  height="40px">
                </b-skeleton-img>
                <b-skeleton-img
                  no-aspect
                  animation="fade"
                  width="60px"
                  height="40px">
                </b-skeleton-img>
                </div>
              </template>
            </b-skeleton-wrapper>
            <li
              v-for="(menuItem, m) of headerItems"
              :key="`menu-${m}`"
              class="c-menu__item d-none d-lg-block me-4">
              <a
                :href="menuItem.url"
                :target="menuItem.redireccionar ? '_blank' : '_self'"
                class="fs-18 w-sbold">
                {{ menuItem.texto }}
              </a>
            </li>
          <!-- <li class="c-menu__item d-none d-lg-block me-4">
            <a href="/cursos/" class="fs-18 w-sbold">Cursos</a>
          </li>
          <li class="c-menu__item d-none d-lg-block me-4">
            <a href="/blog/" class="fs-18 w-sbold">Blog</a>
          </li>
          <li v-if="arcux.project.menu_news" class="c-menu__item d-none d-lg-block me-4">
            <a :href="arcux.project.menu_news" target="_blank" class="fs-18 w-sbold">Eventos</a>
          </li>
          <li v-if="arcux.project.menu_live" class="c-menu__item d-none d-lg-block me-4">
            <a :href="arcux.project.menu_live" target="_blank" class="fs-18 w-sbold">En vivo</a>
          </li>

          <li
            v-if="!isUserLoggedIn"
            class="c-menu__item d-none d-lg-block me-4">
            <a
              id="11"
              data-message="Premium"
              href="/planes"
              class="mx-button-upgrade-plan fs-18 w-sbold"
            >
              Premium
            </a>
          </li> -->
          <li class="d-none d-lg-block">
            <form @submit="search($event)" class="c-browser c-form c-form--black d-flex">
              <input
                v-model="searchWord"
                class="c-browser__input c-form__input"
                type="text"
                name="s"
                placeholder="Explora nuestro mundo..."
              >
              <button class="c-browser__button c-button c-button--primary
                d-flex justify-content-center align-items-center"
              >
                <i class="c-icon icon-search" />
              </button>
            </form>
          </li>
        </template>
      </ul>
      <ul v-if="!single" class="c-nav__right c-menu ul-reset h-100 d-flex align-items-center">
        <button @click="menu = !menu" class="c-link c-link--white me-3 d-lg-none">
          <i class="icon-search d-flex align-items-center"></i>
        </button>

        <b-skeleton-wrapper :loading="isLoading">
          <template #loading>
            <div class="row">
              <div class="col col-6">
                <div class="br--small overflow-hidden">
                  <b-skeleton-img
                    no-aspect
                    animation="fade"
                    width="100px"
                    height="40px">
                  </b-skeleton-img>
                </div>
              </div>
              <div class="col col-6">
                <div class="br--small overflow-hidden">
                  <b-skeleton-img
                    no-aspect
                    animation="fade"
                    width="100px"
                    height="40px">
                  </b-skeleton-img>
                </div>
              </div>
            </div>
          </template>

          <template v-if="isUserLoggedIn">
            <li v-if="!isUserSuscriber" class="c-menu__item d-none d-lg-block">
              <a
                id="1"
                data-message="Sube a premium"
                href="/planes"
                class="c-button c-button--primary-gradient mx-button-upgrade-plan
                  d-flex align-items-center me-4"
              >
                <i class="iconf-king d-flex align-items-center me-2" />
                Sube a premium
              </a>
            </li>

            <Notifications
              :body="user"
              device="multi"
            >
            </Notifications>

            <Profile :body="user" device="multi"></Profile>
          </template>
          <template v-else>
            <li class="c-menu__item d-none d-lg-block">
              <a :href="signInLink.url" class="sign-in fs-18 w-sbold">Entrar</a>
            </li>
            <li class="c-menu__item d-none d-lg-block ms-4">
              <a :href="signUpLink.url" class="c-button c-button--primary d-block">Registrarse</a>
            </li>
          </template>
        </b-skeleton-wrapper>

        <li class="h-100 d-flex d-lg-none align-items-center ms-4">
          <input id="hamburger" v-model="menu" class="c-hamburger-cbox d-none" type="checkbox">
          <label class="c-hamburger d-flex flex-column" for="hamburger">
            <span class="c-hamburger__line c-hamburger__line--1 mb-2" />
            <span class="c-hamburger__line c-hamburger__line--2 mb-2" />
            <span class="c-hamburger__line c-hamburger__line--3" />
          </label>
          <nav class="c-menu-dropwdown position-absolute w-100 bg-darks">
            <div class="container">
              <ul class="ul-reset d-flex flex-column align-items-center">
                <li class="c-menu__item mb-4 mt-3">
                  <form
                    @submit="search($event)"
                    class="c-browser c-form c-form--black d-flex"
                    action="/"
                    method="get">
                    <input
                      v-model="searchWord"
                      class="c-browser__input c-form__input"
                      type="text"
                      name="s"
                      placeholder="Explora nuestro mundo..."
                    >
                    <button
                      class="c-browser__button c-button c-button--primary
                        d-flex justify-content-center align-items-center"
                    >
                      <i class="c-icon icon-search" />
                    </button>
                  </form>
                </li>

                <!-- MENU mobile -->
                <li
                  v-for="(menuItem, m) of headerItems"
                  :key="`menu-${m}`"
                  class="c-menu__item mb-4">
                  <a
                    :href="menuItem.url"
                    :target="menuItem.redireccionar ? '_blank' : '_self'"
                    class="fs-18 w-sbold d-block">
                    {{ menuItem.texto }}
                  </a>
                </li>

                <!-- <li class="c-menu__item mb-4">
                  <a href="/cursos/" class="fs-18 w-sbold d-block">Cursos</a>
                </li>
                <li class="c-menu__item mb-4">
                  <a href="/blog/" class="fs-18 w-sbold d-block">Blog</a>
                </li>

                <li
                  v-if="!isUserLoggedIn"
                  id="11"
                  data-message="Premium"
                  class="c-menu__item mb-4">
                  <a href="/planes" class="mx-button-upgrade-plan fs-18 w-sbold">
                    Premium
                  </a>
                </li>

                <li v-if="arcux.project.menu_news" class="c-menu__item mb-4">
                  <a :href="arcux.project.menu_news" target="_blank" class="fs-18 w-sbold">
                    Eventos
                  </a>
                </li>

                <li v-if="arcux.project.menu_live" class="c-menu__item mb-4">
                  <a :href="arcux.project.menu_live" target="_blank" class="fs-18 w-sbold">
                    En vivo
                  </a>
                </li> -->

                <b-skeleton-wrapper :loading="isLoading">
                  <template #loading>
                    <div class="row align-items-center">
                      <div class="col col-12 mb-4">
                        <div class="br--small overflow-hidden d-flex justify-content-center">
                          <b-skeleton-img
                            no-aspect
                            animation="fade"
                            width="100px"
                            height="40px">
                          </b-skeleton-img>
                        </div>
                      </div>
                      <div class="col col-12">
                        <div class="br--small overflow-hidden d-flex justify-content-center">
                          <b-skeleton-img
                            no-aspect
                            animation="fade"
                            width="100px"
                            height="40px">
                          </b-skeleton-img>
                        </div>
                      </div>
                    </div>
                  </template>

                  <template v-if="!isUserLoggedIn">
                    <li class="c-menu__item mb-4">
                      <a :href="signInLink.url" class="fs-18 w-sbold d-block">Entrar</a>
                    </li>
                    <li class="c-menu__item">
                      <a :href="signUpLink.url" class="c-button c-button--primary d-block">
                        Registrarse
                      </a>
                    </li>
                  </template>
                  <template v-else>
                    <li v-if="!isUserSuscriber" class="c-menu__item">
                      <a
                        id="1"
                        data-message="Sube a premium"
                        href="/planes"
                        class="c-button c-button--primary-gradient mx-button-upgrade-plan
                          d-flex align-items-center"
                      >
                        <i class="iconf-king d-flex align-items-center me-2" />
                        Sube a premium
                      </a>
                    </li>
                  </template>
                </b-skeleton-wrapper>
              </ul>
            </div>
          </nav>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      arcux: window.arcux,
      user: null,

      headerItems: [],
      headerLoading: true,

      menu: false,
      searchWord: '',

      isLoading: true,
    };
  },
  props: ['type', 'single'],
  components: {
    Notifications: () => import(/* webpackChunkName: "notifications" */'./Notifications.vue'),
    Profile: () => import(/* webpackChunkName: "profile" */'./Profile.vue'),
  },
  computed: {
    ...mapState({
      userData: (state) => state.user.userData,
    }),

    authToken() {
      return this.$store.state.authToken;
    },
    isUserLoggedIn() {
      return this.userData && this.userData.id;
    },
    isUserSuscriber() {
      return this.isUserLoggedIn && this.userData.membership;
    },

    query() {
      return (this.$route.query.back_url && this.$route.query.plan) ? `?back_url=${this.$route.query.back_url}&plan=${this.$route.query.plan}` : '';
    },
    signInLink() {
      return { url: `/panel/ingresar/${this.query}` };
    },
    signUpLink() {
      return { url: `/panel/registrarse/${this.query}` };
    },
  },
  watch: {
    userData(data) {
      this.user = data;

      this.isLoading = false;
    },
  },
  mounted() {
    this.getHeaderData();
    if (this.userData && this.userData.id) {
      this.user = this.userData;
      this.isLoading = false;
    } else {
      this.isLoading = false;
    }
  },
  methods: {
    search(e) {
      e.preventDefault();

      window.location.href = `/es/cursos/search/results?q=${this.searchWord}`;
    },

    getHeaderData() {
      const request = `${process.env.VUE_APP_API}/pages/sections/header`;
      fetch(request)
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.headerItems = response.data?.menu;
            this.headerLoading = false;
          }
        })
        .catch(() => { });
    },
  },
};
</script>
